module.exports = __webpack_public_path__ + "img/Tunisia.250b8287.gif";